import balanceJson from '@tdmons/data/balance.json';

/** Every tunable number in the game. Edit packages/data/balance.json, never this file. */
export type Balance = typeof balanceJson;

export const balance: Balance = balanceJson;

export function ppAfterDivisor(dexPP: number, b: Balance = balance): number {
  return Math.max(1, Math.ceil(dexPP / b.moves.ppDivisor));
}
